'use client';

import { useCallback } from 'react';
import { UIMarket } from '@drift/common';
import MarketIcon from 'src/components/Utils/MarketIcon';
import { BalanceRowData } from './types';
import { cm } from 'src/utils/classNames';
import { usePrivyWalletContext } from 'src/providers/wallets/PrivyWalletProvider';

interface AssetCellProps {
	row: BalanceRowData;
	handleSelection: (marketIndex: number) => void;
}

export function AssetCell({ row, handleSelection }: AssetCellProps) {
	const { isPrivyNativeAuth } = usePrivyWalletContext();

	const { spotMarketIndex, highlighted } = row;
	const uiMarket = UIMarket.createSpotMarket(spotMarketIndex);

	const isClickable = !uiMarket.isUsdcMarket && !isPrivyNativeAuth;

	const handleClick = useCallback(() => {
		if (!isClickable) {
			return;
		}

		handleSelection(spotMarketIndex);
	}, [spotMarketIndex, isClickable, handleSelection]);

	return (
		<div
			className={cm(
				'flex items-center gap-x-2',
				isClickable && 'cursor-pointer'
			)}
			onClick={handleClick}
		>
			<MarketIcon
				marketSymbol={uiMarket.uiSymbols.marketDisplaySymbol}
				className="size-5"
			/>
			<span
				className={cm(
					'max-w-[70px] truncate typo-t4',
					highlighted && 'font-semibold'
				)}
			>
				{uiMarket.uiSymbols.marketDisplaySymbol}
			</span>
		</div>
	);
}
